/**
 * landingGate — shared throttle constants for the pre-app welcome carousel.
 *
 * Why a module: ProtectedShell decides whether to send a returning user to
 * /welcome, and the welcome page stamps the "last shown" timestamp. Both
 * sides MUST agree on the storage key and the throttle window — defining
 * them once here prevents the kind of silent drift bug where the gate keeps
 * firing because one side reads a different key.
 */

// Once per hour per device. The user opens the app via bookmark / saved
// login → if it's been >1h since they last saw the welcome carousel on
// THIS device (localStorage), we route them through /welcome on the way
// into the app.
export const LANDING_THROTTLE_MS = 60 * 60 * 1000;

// localStorage key used by safeStorage. Cosmetic-only — no PII or session
// material, so it lives alongside theme/density prefs.
export const LANDING_TIMESTAMP_KEY = 'polkdesq_landing_last_shown';

// How long an authed user lingers on /welcome before we auto-advance them
// into the app. The user can click "Open Dashboard" sooner.
export const WELCOME_AUTO_ADVANCE_SECONDS = 30;
